export const FIELD_IS_REQUIRED = 'Field can’t be empty';
export const FIELD_MUST_BE_EMPTY = 'Field must be empty';
export const FIELD_MAX_LENGTH = 'Length is too long';
export const FIELD_IS_GREATER_THAN_ZERO = 'Value must be greater than 0';
export const FIELD_IS_NUMERIC_STRING = 'Field can have only digits';
export const FIELD_IS_INTEGER = 'Field can have only integer number';

export const toFieldMinimumValueErrorMessage = (fieldName: string, minValue: number) =>
  `${fieldName} can't be less than ${minValue}`;

export const toFieldMaximumValueErrorMessage = (fieldName: string, maxValue: number) =>
  `${fieldName} can't be more than ${maxValue}`;

export const ZIP_LENGTH_ERROR = 'Must be exactly 5 digits';
export const POSTAL_CODE_ERROR = 'Invalid postal code format';

export const PHONE_EXT_MAX_ERROR = 'No more than 5 digits';

export const INVALID_DATE = 'Date is not valid';

export const EMAIL = `Email isn't valid`;
export const EMAIL_TOO_LONG = 'Email is too long (length is more than 200)';

export const URL = `URL isn't valid`;

export const PHONE_ERROR_AT_LEAST_ONE_NUMBER_REQUIRED = 'Enter at least one phone number';
export const PHONE_ERROR_INVALID_NUMBER = 'Invalid phone number entered';
